import { callLambdaApi } from "../callLambdaApi";
import { ApiNames, Methods } from "../constants";
import { getLogger } from "utils";

const logger = getLogger(true, "ModelApiCommunicator");

export class ModelApiCommunicator {
  create(
    requestBody = {
      gcPrintProjectName: "SomeOtherProjectAgain.project",
      notes: "some note",
      modelName: "New Model",
    }
  ) {
    return callLambdaApi({
      method: Methods.POST,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
      payload: {
        body: {
          ...requestBody,
        },
      },
    });
  }

  /**
   * @param {string} modelId
   * @returns {Promise<import('api').GETResponse<import('models').Model>}
   */
  fetch(modelId) {
    logger.info("fetch()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${modelId}`,
    });
  }

  /**  @returns {Promise<import('api').GETResponse<import("models").Model[]>} */
  list() {
    logger.info("list()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
    });
  }

  update(requestBody) {
    return callLambdaApi({
      method: Methods.PUT,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${requestBody.modelId}`,
      payload: { body: requestBody },
    });
  }

  delete(modelId) {
    return callLambdaApi({
      method: Methods.DELETE,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${modelId}`,
    });
  }

  /**
   * Returns the default serverless api endpoint
   * using the instance's project and model ids.
   * @private
   */
  _buildBaseURL() {
    return `/model`;
  }
}
